import { PlatformFSContext } from './core/context'
import { useDeleteCore } from './core/hooks/useDelete'
import type { IFile } from './core/types'

const platformContext = new PlatformFSContext()

export function useDelete() {
  const { deleteFiles: coreDeleteFiles } = useDeleteCore(platformContext)

  // Backward compatible signature - dir parameter is now ignored since file.path is already complete
  const deleteFiles = async (selectedRows: IFile[], _dir: string, domain: number) => {
    return coreDeleteFiles(selectedRows, domain)
  }

  return {
    deleteFiles,
  }
}
